import type { DeviceStatus } from '../../types';

interface StatusBadgeProps {
  status: DeviceStatus | string;
  className?: string;
}

const StatusBadge = ({ status, className = '' }: StatusBadgeProps) => {
  const getStatusStyle = () => {
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase() : status;
    switch (normalizedStatus) {
      case 'online':
      case 'up':
      case 'active':
        return 'bg-success-100 text-success-700 border-success-200';
      case 'offline':
      case 'down':
      case 'inactive':
        return 'bg-gray-100 text-gray-700 border-gray-200';
      case 'disconnect':
      case 'error':
      case 'failed':
      case 'revoked':
        return 'bg-danger-100 text-danger-700 border-danger-200';
      case 'pending':
      case 'warning':
        return 'bg-warning-100 text-warning-700 border-warning-200';
      default:
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusStyle()} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full mr-1.5 bg-current"></span>
      {status}
    </span>
  );
};

export default StatusBadge;

